import { Navigate } from "react-router-dom";
import { getAccessToken } from "../utils";

const PublicRoute = ({ children }: any) => {
  return getAccessToken() ? <Navigate to="/adoption" /> : children;
};
export default PublicRoute;
